import { useCountDown } from '@gamiphy/loyalty-station-desktop/components/promotion/hooks';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { useTranslation } from '@gamiphy/react-i18n';
import {
  Box, Grid,
  Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

type Props = {
  fontSize: string,
  labelsFontSize: string,
  margin: string,
}

const BirthDayCountDown: React.FC<Props> = (observer(({
  fontSize, labelsFontSize, margin,
}) => {
  const { t } = useTranslation();

  const {
    days,
    hours,
    minutes,
  } = useCountDown(UserStore.currentYearBirthDate);

  return (
    <Grid
      container
      direction="column"
      sx={{
        height: '100%',
        width: '100%',
        justifyContent: 'space-between',
        color: 'primary.main',
        mt: margin,
      }}
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid
        container
        sx={{
          fontSize: '1rem',
          lineHeight: 1,
          textAlign: 'center',
          fontWeight: 600,
        }}
        justifyContent="center"
        wrap="nowrap"
      >
        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid sx={{ fontSize, fontWeight: 600 }}>
            <Grid container spacing={1}>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {days ? Math.floor(days / 10) : 0}
                  </Typography>
                </Box>
              </Grid>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {days ? days % 10 : 0}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid sx={{
            fontSize: labelsFontSize,
            lineHeight: 2,
            fontWeight: 'normal',
          }}
          >
            {t('pointsExpiry.units.days', { defaultValue: 'Days' })}
          </Grid>
        </Grid>
        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid sx={{ fontSize, fontWeight: 600 }}>
            <Grid container spacing={1}>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {hours ? Math.floor(hours / 10) : 0}
                  </Typography>
                </Box>
              </Grid>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {hours ? hours % 10 : 0}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid sx={{
            fontSize: labelsFontSize,
            lineHeight: 2,
            fontWeight: 'normal',
          }}
          >
            {t('hours', 'Hours')}
          </Grid>
        </Grid>
        <Grid container direction="column" alignItems="center" spacing={1}>
          <Grid sx={{ fontSize, fontWeight: 600 }}>
            <Grid container spacing={1}>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {minutes ? Math.floor(minutes / 10) : 0}
                  </Typography>
                </Box>
              </Grid>
              <Grid>
                <Box
                  sx={{
                    padding: 1,
                    borderRadius: 1,
                    backgroundColor: '#0028461A',
                    minWidth: '28px',
                    alignSelf: 'center',
                  }}
                >
                  <Typography fontSize={fontSize} fontWeight={600} color="primary">
                    {minutes ? minutes % 10 : 0}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid sx={{
            fontSize: labelsFontSize,
            lineHeight: 2,
            fontWeight: 'normal',
          }}
          >
            {t('minutes', 'Minutes')}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}));

export default BirthDayCountDown;
